import React from 'react';
import ContactUsButton from '../components/ContactUsButton';

const ReunionRulesPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="services-page">
        <div className="services-container">
          <p className="breadcrumb">Services / Reunions</p>
          <h1 className="page-title">Reunions</h1>
          <p className="page-subtitle">
            Guidelines and information for hosting family or class reunions at TDS Event Center.
          </p>
          <div className="page-header-actions">
            <ContactUsButton
              buttonText="Click here to ask questions"
              className="contact-button contact-button-alt"
              defaultService="Reunions"
              defaultInquiry="information"
            />
          </div>

          <div className="rules-section">
            <h2>Venue Usage</h2>
            <ul>
              <li>Reunion reservations include access to designated event areas and common spaces.</li>
              <li>Outdoor spaces may be available based on season and weather conditions.</li>
              <li>All event activities must be kept within the reserved areas.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Food &amp; Beverages</h2>
            <ul>
              <li>Potluck-style events are allowed, provided all food is handled safely.</li>
              <li>Catered events must follow the same requirements as other catered functions.</li>
              <li>All food and beverage service must be completed by the event end time.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Activities &amp; Entertainment</h2>
            <ul>
              <li>Music and entertainment must respect volume limits and quiet hours.</li>
              <li>Games and activities should be planned to ensure safety for all ages.</li>
              <li>Any special equipment must be approved in advance.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>General Policies</h2>
            <ul>
              <li>Children must be supervised by an adult at all times.</li>
              <li>All decorations and personal items must be removed at the end of the event.</li>
              <li>Any damages may result in additional charges as outlined in the rental agreement.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ReunionRulesPage;


